import { USER_AVATAR_STYLE_MAP, UserAvatarProps } from "@faro-lotv/flat-ui";
import type { JSX } from "react";
import {
  UserTeamAvatar,
  UserTeamAvatarProps,
} from "../../users-invite/user-team-avater";

/** @returns the UserAvatar to use in the card that handle the undefined case retaining the expected size */
export function CardUserAvatar({
  userDisplayInfo,
  isTeam,
}: Pick<UserAvatarProps, "userDisplayInfo"> &
  Pick<UserTeamAvatarProps, "isTeam">): JSX.Element {
  if (!userDisplayInfo) {
    return (
      <div
        style={{
          width: USER_AVATAR_STYLE_MAP.xs.wrapperSize,
          height: USER_AVATAR_STYLE_MAP.xs.wrapperSize,
        }}
      />
    );
  }

  return (
    <UserTeamAvatar
      size="xs"
      userDisplayInfo={userDisplayInfo}
      isTeam={isTeam}
    />
  );
}
